import { create } from "zustand";

const useCelebritiesStore = create((set) => ({
  celebrities: undefined,
  storeCelebrities: (celebrities) =>
    set((state) => ({ ...state, celebrities: celebrities })),
}));

export default useCelebritiesStore;
